import packageInfo from "../package.json";
import * as Sentry from "@sentry/react";
import { getWindowR360 } from "./Helper";

export const initSentry = () => {
    const r360Window = getWindowR360();

    // Don't run Sentry in local environment by default. Can be used for debugging.
    if (r360Window.__ENVIRONMENT__ !== "local" && r360Window.__ENVIRONMENT__ !== null) {
        Sentry.init({
            dsn: "https://268733973846e6b2f95af21ebc6fa89c@o4507566543798272.ingest.de.sentry.io/4508895953027152",
            release: packageInfo.version.includes("RELEASE") ? "0" : packageInfo.version,
            environment: r360Window.__ENVIRONMENT__,
            beforeBreadcrumb(breadcrumb) {
                // Exclude warnings about componentWillReceiveProps, componentWillUpdate, as they are not relevant to the breadcrumb.
                if (
                    breadcrumb.message?.includes("componentWillReceiveProps has been renamed") ||
                    breadcrumb.message?.includes("componentWillUpdate has been renamed")
                ) {
                    return null; // Ignore this breadcrumb.
                }

                return breadcrumb; // Keep other breadcrumbs.
            },
        });

        Sentry.setTag("server_name", r360Window.__SERVER_NAME__);
        Sentry.setTag("module", "booking");
        Sentry.setTag("site", r360Window.__SITE__);
        Sentry.setTag("codebase", r360Window.__CODEBASE__ || "N/A");
        Sentry.setTag("lang", r360Window.__LANG__);

        console.log("Sentry initialized");
    }
};

export const isSentryInitialized = () => {
    return !!Sentry.getCurrentScope()?.getClient();
};

export const getSentryBreadcrumbMiddlewareForRedux =
    (actionsToIgnore = []) =>
    (store: any) =>
    (next: any) =>
    (action: any) => {
        if (actionsToIgnore.some(type => action.type.includes(type))) {
            return next(action); // Skip logging this action
        }

        if (!isSentryInitialized()) {
            return next(action); // Skip logging if Sentry is not initialized
        }

        Sentry.addBreadcrumb({
            category: "Redux action",
            message: action.type,
            level: "info",
        });

        return next(action);
    };
